import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Video } from "lucide-react";
import { buildWhatsAppLink } from "../lib/api";
import { APPOINTMENT_TEXT } from "../lib/home-content";

const links = [
  { hash: "#top",        label: "Home",           id: "home" },
  { hash: "#collection", label: "Our Collection", id: "collection" },
  { hash: "#about",      label: "About",          id: "about" },
  { hash: "#showroom",   label: "Visit Us",       id: "visit" },
  { hash: "#contact",    label: "Contact",        id: "contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = (hash) => (e) => {
    e.preventDefault();
    setOpen(false);
    if (location.pathname === "/") {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      // update URL hash without reloading
      window.history.replaceState(null, "", hash === "#top" ? "/" : `/${hash}`);
    } else {
      navigate(hash === "#top" ? "/" : `/${hash}`);
    }
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F4F7FE]/85 border-b border-[#DCE4F2]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between py-5">
        <Link
          to="/"
          onClick={handleNav("#top")}
          data-testid="nav-brand"
          className="flex items-center leading-none"
        >
          <img
            src="/images/logo.jpg"
            alt="Style India · Manufacturer & Wholesaler"
            className="h-20 md:h-24 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.hash}
              href={l.hash === "#top" ? "/" : `/${l.hash}`}
              onClick={handleNav(l.hash)}
              data-testid={`nav-${l.id}-link`}
              className="nav-link text-[12px] tracking-[0.22em] uppercase font-medium text-[#0F1245]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={buildWhatsAppLink(APPOINTMENT_TEXT)}
          target="_blank"
          rel="noreferrer"
          data-testid="nav-cta-appointment"
          className="hidden md:inline-flex btn-primary !py-3 !px-5 text-[10px]"
        >
          <Video size={12} strokeWidth={1.5} /> Book Video Call
        </a>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          className="md:hidden p-2"
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#DCE4F2] bg-[#F4F7FE]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.hash}
                href={l.hash === "#top" ? "/" : `/${l.hash}`}
                onClick={handleNav(l.hash)}
                data-testid={`nav-mobile-${l.id}-link`}
                className="text-[13px] tracking-[0.22em] uppercase font-medium text-[#0F1245]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={buildWhatsAppLink(APPOINTMENT_TEXT)}
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="btn-primary justify-center mt-4"
            >
              <Video size={14} strokeWidth={1.5} /> Book Video Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
